/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_467cd672 .ms-Suggestions-itemButton{padding:0;border:none}.callout_467cd672 .ms-Suggestions{min-width:300px}"}]);
export const callout = "callout_467cd672";